import React from 'react'
import { graphql } from 'gatsby'
import Img from 'gatsby-image'
import { Helmet } from 'react-helmet'
import styled from 'styled-components'

import Header from '../components/Header'
import Layout from '../components/Layout'
import Optimize from '../components/Optimize'
import Footer from '../components/Footer'
import Steps from '../components/Steps'
import List from '../components/List'
import Features from '../components/Features'
import Title from '../components/Title'
import Intro from '../components/Intro'
import StickyBar from '../components/StickyBar'
import ContentCard from '../components/ContentCard'
import ContentPay from '../components/ContentPay'
import BadgesCards from '../components/BadgesCards'
import Content from '../components/Content'
import CardFlyout from '../components/CardFlyout'
import ContentApp from '../components/ContentApp'
import Break from '../components/Break'
import OnScroll from '../components/OnScroll'
import CardCSC from '../components/CardCSC'

const CardCSCContent = styled.div`
  margin-top: 8px;

  @media (min-width: 768px) {
    margin-bottom: -10px;
  }
`

const CardCSCTitle = styled.div`
  margin: 0;
  padding: 0;
  font-size: 20px;
  font-family: 'BentonSans';
  font-weight: 900;
  line-height: 1.2;

  @media (max-width: 768px) {
    font-size: 26px;
    text-transform: uppercase;
    margin-bottom: 16px;
  }
`

const theme = {
  name: 'green',
}

export const query = graphql`
  fragment contentImageGreen on File {
    childImageSharp {
      fluid(maxWidth: 630, maxHeight: 600, quality: 100) {
        ...GatsbyImageSharpFluid
      }
    }
  }

  fragment appScreenImageGreen on File {
    childImageSharp {
      fixed(width: 280, height: 604) {
        ...GatsbyImageSharpFixed
      }
    }
  }

  query {
    contentImage1Green: file(relativePath: { eq: "content_01_green.jpg" }) {
      ...contentImageGreen
    }
    contentImage1aGreen: file(relativePath: { eq: "content_01a_green.jpg" }) {
      ...contentImageGreen
    }
    contentImage2Green: file(relativePath: { eq: "content_02_green.jpg" }) {
      ...contentImageGreen
    }
    contentImage3Green: file(relativePath: { eq: "content_03_green.jpg" }) {
      ...contentImageGreen
    }
    contentImage4Green: file(relativePath: { eq: "content_04_green.jpg" }) {
      ...contentImageGreen
    }
    cardImageGreen: file(relativePath: { eq: "card_green.png" }) {
      childImageSharp {
        intro: fixed(width: 432, height: 274) {
          ...GatsbyImageSharpFixed
        }
        small: fixed(height: 36) {
          ...GatsbyImageSharpFixed
        }
        default: fixed(width: 410) {
          ...GatsbyImageSharpFixed
        }
        fluid(maxWidth: 630, quality: 100) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    cardImageGoldBusiness: file(
      relativePath: { eq: "card_gold_business.png" }
    ) {
      childImageSharp {
        default: fixed(width: 290) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    payMobileImageGreen: file(relativePath: { eq: "pay_mobile_green.png" }) {
      childImageSharp {
        fixed(width: 360, height: 379) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    appMobileImageGreen: file(relativePath: { eq: "app_mobile_green.png" }) {
      childImageSharp {
        fixed(width: 360, height: 555) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    watchImageGreen: file(relativePath: { eq: "watch_green.png" }) {
      childImageSharp {
        fixed(width: 272, height: 466) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    walletImageGreen: file(relativePath: { eq: "Wallet_Green_wSB.png" }) {
      ...appScreenImageGreen
    }
    appScreenImage1Green: file(
      relativePath: { eq: "01_App_Start_Green_wSB.png" }
    ) {
      ...appScreenImageGreen
    }
    appScreenImage2Green: file(
      relativePath: { eq: "02_App_Timeline_Green_wSB.png" }
    ) {
      ...appScreenImageGreen
    }
    appScreenImage3Green: file(
      relativePath: { eq: "03_App_Offers_Green_wSB.png" }
    ) {
      ...appScreenImageGreen
    }
    appScreenImage4Green: file(
      relativePath: { eq: "04_App_Konto_Green_wSB.png" }
    ) {
      ...appScreenImageGreen
    }
    badgeRightImageGreen: file(relativePath: { eq: "badge_right_green.png" }) {
      childImageSharp {
        fixed(width: 148) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    introImageGreen: file(relativePath: { eq: "intro_green.jpg" }) {
      childImageSharp {
        fixed(width: 3120) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    introTabletImageGreen: file(
      relativePath: { eq: "intro_tablet_green.jpg" }
    ) {
      childImageSharp {
        fixed(width: 2048) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    introMobileImageGreen: file(
      relativePath: { eq: "intro_mobile_green.jpg" }
    ) {
      childImageSharp {
        fixed(width: 1440) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    introPatternImageGreen: file(
      relativePath: { eq: "intro_pattern_green.png" }
    ) {
      childImageSharp {
        fixed(width: 319, height: 153) {
          ...GatsbyImageSharpFixed
        }
      }
    }
  }
`

const tracking = `


<script src="http://www.americanexpress.com/adobetrackingconsent"></script>

<!-- Google Tag Manager (noscript) -->
<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-WSV8C65"
height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
<!-- End Google Tag Manager (noscript) -->

<!-- Facebook Pixel Code -->
<script>
!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
document,'script','https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '562383967540068');
fbq('track', 'PageView');
</script>
<noscript><img height="1" width="1" style="display:none"
src="//www.facebook.com/tr?id=562383967540068&amp;ev=PageView&noscript=1"
/></noscript>
<!-- DO NOT MODIFY -->
<!-- End Facebook Pixel Code -->

<!-- Google Code for Remarketing Tag -->
<!--------------------------------------------------
Remarketing tags may not be associated with personally identifiable information or placed on pages related to sensitive categories. See more information and instructions on how to setup the tag on: http://google.com/ads/remarketingsetup
--------------------------------------------------->
<script type="text/javascript">
/* <![CDATA[ */
var google_conversion_id = 975872748;
var google_custom_params = window.google_tag_params;
var google_remarketing_only = true;
/* ]]> */
</script>
<script type="text/javascript" src="//www.googleadservices.com/pagead/conversion.js">
</script>
<noscript>
<div style="display:inline;">
<img height="1" width="1" style="border-style:none;" alt="" src="//googleads.g.doubleclick.net/pagead/viewthroughconversion/975872748/?guid=ON&amp;script=0"/>
</div>
</noscript>

<script type='text/javascript'>
// Conversion Name: American-Express_Landingpage_Retargeting_GreenCard
var ebRand = Math.random()+'';
ebRand = ebRand * 1000000;
//<![CDATA[
document.write('<scr'+'ipt src="HTTPS://bs.serving-sys.com/Serving/ActivityServer.bs?cn=as&amp;ActivityID=1218612&amp;rnd=' + ebRand + '"></scr' + 'ipt>');
//]]>
</script>
<noscript>
<img width="1" height="1" style="border:0" src="HTTPS://bs.serving-sys.com/Serving/ActivityServer.bs?cn=as&amp;ActivityID=1218612&amp;ns=1"/>
</noscript>
<!-- Global site tag (gtag.js) - Google AdWords: 877585581 -->
<script async src="https://www.googletagmanager.com/gtag/js?id=AW-877585581"></script>
<script>
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', 'AW-877585581');
</script>
<!-- End Google Code for Remarketing Tag -->

<!-- Event snippet for Green Card beantragt conversion page -->
<script>
gtag('event', 'conversion', {'send_to': 'AW-877585581/9H06CP71soMBEK3Ju6ID'});
</script>
<!-- End Event snippet for Green Card beantragt conversion page -->

<!-- Start Container-Pixel von LightReaction -->
<iframe allowtransparency="true" scrolling="no" frameborder="0" border="0" width="1" height="1" marginwidth="0" marginheight="0" background-color="transparent" src="https://ad2.adfarm1.adition.com/track?tid=14183&sid=39448&type=html&orderid=&itemno=&descr=&quantity=&price=0.00&total=0.00"></iframe>
<!-- End Container-Pixel von LightReaction -->

<!-- Start Pixel EDA Programmatic Unit UM AMEX London -->
<img height="1" width="1" style="border-style:none;" alt="" src="//insight.adsrvr.org/track/conv/?adv=5t0y1jn&ct=0:a6j6g1b&fmt=3"/>
<!-- End EDA Programmatic Unit UM AMEX London -->

<!--
Start of DoubleClick Floodlight Tag: Please do not remove
Activity name of this tag: FAST – Germany Green Card Product Page – D2
URL of the webpage where the tag is expected to be placed: https://www.amex-kreditkarten.de/angebot-green/
This tag must be placed between the opening and closing body tags, as close as possible to the opening tag.
Creation Date: 06/15/2018
-->
<script type="text/javascript">
var axel = Math.random() + "";
var a = axel * 10000000000000;
document.write('<img src="https://ad.doubleclick.net/ddm/activity/src=3852110;type=ldp;cat=fastg0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=' + a + '?" width="1" height="1" alt=""/>');
</script>
<noscript>
<img src="https://ad.doubleclick.net/ddm/activity/src=3852110;type=ldp;cat=fastg0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=1?" width="1" height="1" alt=""/>
</noscript>
<!-- End of DoubleClick Floodlight Tag: Please do not remove -->

<!-- Segment Pixel 15979832 - DO NOT MODIFY --><script src="https://secure.adnxs.com/seg?add=15979832&t=1" type="text/javascript"></script><!-- End of Segment Pixel -->

<!-- Use of this pixel is subject to the Amazon ad specs and policies at http://www.amazon.com/b/?&node=7253015011 --><img height='1' width='1' border='0' alt='' src='https://aax-eu.amazon-adsystem.com/s/iui3?d=forester-did&ex-fargs=%3Fid%3D6b03927b-5975-ba31-ddad-c5f1453970ad%26type%3D7%26m%3D4&ex-fch=416613&ex-src=https://www.americanexpress.com/de/kreditkarte/american-express-card/&ex-hargs=v%3D1.0%3Bc%3D5765058860102%3Bp%3D6B03927B-5975-BA31-DDAD-C5F1453970AD' />

<!-- Universal Tracking Tag Amex Green -->
<script type="text/javascript" charset="utf-8">
	var utm268 = {};
	utm268.data = {
		/* Settings General */
		advertiser_id: 'adv_m10030_1_294', // do not change
		pt_pagetype: 'product', // insert pagetype, possible values: 'home', 'product', 'category', 'conversion'
		pt_checkout: '', // insert orderstep 1-n (optional)
		/* Conversion */
		pt_conversion: '', // specify your conversion type, e.g. 'lead' or 'order' (optional)
		pt_conversion_orderid: '', // insert your order ID or unique identifer (mandatory)
		pt_conversion_total: '', // insert value of basket (optional)
		pt_conversion_quantity: '', // insert number of purchased products (optional)
		pt_conversion_success: '', // if Lasttouch / deduplication (Cookie-Weiche) insert 1, for hardcoded 0; Default 0
		/* Settings Categories */
		pt_category: '', // insert main category
		pt_subcategory1: '', // insert subcategory 1
		pt_subcategory2: '', // insert subcategory 2
		pt_subcategory3: '', // insert subcategory 3
		/* Settings Product */
		pt_productname: 'green', // insert product name
		pt_productid: '', // insert product id
		/* Settings Custom Variables */
		pt_customvar1: '', // insert value for defined customvar1
		pt_customvar2: '', // insert value for defined customvar2
		pt_customvar3: '', // insert value for defined customvar3
		pt_customvar4: '', // insert value for defined customvar4
		pt_customvar5: '', // insert value for defined customvar5
		/* Do not change */
		pt_loc: decodeURI(document.location.href), // do not change
		pt_ref: decodeURI(document.referrer), // do not change
		pt_protocol: (("https:" == document.location.protocol) ? "https://" : "http://"), // do not change
		pt_cachebuster: new Date().getTime() // do not change
	};
	(function(w,d,s,f,v) {
		w[v] = w[v] || [];
		var e = d.getElementsByTagName(s)[0],
			j = d.createElement(s);
		j.async = true;
		j.src = f;
		e.parentNode.insertBefore(j, e);
	})(window, document,"script","https://utt.pm/utm/268/adv_m10030_1_294.js","utm268");
</script>

<!-- End Universal Tracking Tag Amex Green -->

<!-- Begin Exactag -->
<script type="text/javascript">
var exactag = {};
exactag.campaign = "d2cb3973d7b30517a986f08ed7459ae7";
exactag.sitegroup = "landingpage";
</script>
<script type="text/javascript" src="https://cdn.exactag.com/js/exactag.js"></script>
<!-- End Exactag -->

<!-- BEGIN: LinkedIn -->
<script type="text/javascript">
_linkedin_partner_id = "2611937";
window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
window._linkedin_data_partner_ids.push(_linkedin_partner_id);
</script><script type="text/javascript">
(function(){var s = document.getElementsByTagName("script")[0];
var b = document.createElement("script");
b.type = "text/javascript";b.async = true;
b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
s.parentNode.insertBefore(b, s);})();
</script>
<noscript>
<img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=2611937&fmt=gif" />
</noscript>
<!-- END: LinkedIn -->

<!-- BEGIN: Adobe DTM-->
<script>
var digitalData = {
  "version": "3.0",
  "page": {
    "pageInfo": {
      "country": "DE", //L1
      "language": "de",
      "pageName": "CardDetails"
    },
    "category": {
      "businessUnit": "Online", //L2
      "primaryCategory": "Prospect", //L3
      "subCategory1": "CONS", //L4
      "subCategory2": "Basic", //L5
      "subCategory3": "Charge" //L6
    },
    "attributes": {
      "entrypoint": "<EEP Value>",
      "applyFlowID": "<Apply Flow ID>",
      "experience": "Proprietary"
    }
  },
  "event": [{
    "eventInfo": {
      "eventType": "cardApplication",
      "eventAction": "productconsideration"
    },
    "productInfo": [{
      "productName": "greencard",
      "pmc": "<PMC code of the Product>"
    }]
  }]
}
if (typeof(_satellite) != 'undefined') {
  _satellite.pageBottom();
}
if (typeof(digitalData.event) != 'undefined') {
  digitalData.event.length = 0;
}
digitalData.event.push({
  eventInfo: {
  eventAction: "Click",
  eventAsset: "CardDetails_CardArt-GreenCard",
  eventType: "pageInteraction"
  }
})
if (typeof(_satellite) != "undefined") {
  _satellite.track("event");
}
</script>
<!-- END: Adobe DTM -->
`

const appendCssToHead = `
  .async-hide { opacity: 0 !important }
`

const appendJsToHead = `
/* Page Hiding Snippet */
(function(a,s,y,n,c,h,i,d,e){s.className+=' '+y;h.start=1*new Date; h.end=i=function(){s.className=s.className.replace(RegExp(' ?'+y),'')}; (a[n]=a[n]||[]).hide=h;setTimeout(function(){i();h.end=null},c);h.timeout=c; })(window,document.documentElement,'async-hide','dataLayer',4000, {'GTM-MX2TSVW':true});

/* Optimize Container Code */
(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){ (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o), m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m) })(window,document,'script','https://www.google-analytics.com/analytics.js','ga'); ga('create', 'UA-139964173-2', 'auto'); ga('require', 'GTM-MX2TSVW');

/* GTM Container Code */
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-WSV8C65');

/* Pinterest */
!function(e){if(!window.pintrk){window.pintrk = function () {
window.pintrk.queue.push(Array.prototype.slice.call(arguments))};var
n=window.pintrk;n.queue=[],n.version="3.0";var
t=document.createElement("script");t.async=!0,t.src=e;var
r=document.getElementsByTagName("script")[0];
r.parentNode.insertBefore(t,r)}}("https://s.pinimg.com/ct/core.js");
pintrk('load', '2612918883631', {em: '<user_email_address>'});
pintrk('page');
`

const euLocale = `
  window.euLocale = 'DE_de';
`

const variant = 'angebot-green'

const GreenPage = ({ data }) => (
  <Layout theme={theme}>
    <Helmet>
      <style type="text/css">{`${appendCssToHead}`}</style>
      <script type="application/javascript">{`${appendJsToHead}`}</script>
      <noscript>
        {`<!-- Pinterest--><img height="1" width="1" style="display:none;" alt="" src="https://ct.pinterest.com/v3/?event=init&tid=2612918883631&pd[em]=<hashed_email_address>&noscript=1" />`}
      </noscript>
      <script type="application/javascript">{`${euLocale}`}</script>
      <script type="application/javascript" src="https://www.americanexpress.com/ensighten-head-intl"></script>
      <script src="https://www.americanexpress.com/adobedtm-acq"></script>
    </Helmet>

    <Header currentCard="green" currentVariant={variant} />

    <Intro
      variant={variant}
      linkedin
      pretitle="Immer an Ihrer Seite"
      title={
        <>
          Die American
          <br />
          Express Card
        </>
      }
      text={
        <List color="white" bold>
          <List.Item>
            Nur 5 Euro im Monat inkl. 1 Zusatzkarte<sup>3)</sup>
          </List.Item>
          <List.Item>
            Ab dem 2. Jahr kostenfrei – abhängig vom Jahresumsatz<sup>1)</sup>
          </List.Item>
          <List.Item>Mit jedem Einkauf Punkte sammeln</List.Item>
        </List>
      }
      mobileText={
        <List color="white">
          <List.Item>
            Nur 5 Euro im Monat inkl. 1 Zusatzkarte<sup>3)</sup>
          </List.Item>
          <List.Item>
            Ab dem 2. Jahr kostenfrei – abhängig vom Jahresumsatz<sup>1)</sup>
          </List.Item>
          <List.Item>Mit jedem Einkauf Punkte sammeln</List.Item>
        </List>
      }
      infoTitle={
        <>
          NUR 5 EURO IM MONAT
        </>
      }
      infoMeta={<>+ 1 Zusatzkarte kostenfrei<sup>3)</sup></>}
      image={data.introImageGreen.childImageSharp.fixed}
      tabletImage={data.introTabletImageGreen.childImageSharp.fixed}
      mobileImage={data.introMobileImageGreen.childImageSharp.fixed}
      patternImage={data.introPatternImageGreen.childImageSharp.fixed}
      cardImage={data.cardImageGreen.childImageSharp.intro}

    />

    <StickyBar
      variant={variant}
      linkedin
      card={data.cardImageGreen.childImageSharp.small}
      title="American Express Card"
      mobileSubline={
        <>
          + 1 Zusatzkarte kostenfrei<sup>3)</sup>
        </>
      }
      content={
        <List small inline>
          <List.Item>
            <strong>Nur 5 Euro im Monat inkl. 1 Zusatzkarte<sup>3)</sup></strong>
          </List.Item>
          <List.Item>
            <strong>Ab dem 2. Jahr kostenfrei – abhängig vom Jahresumsatz<sup>1)</sup></strong>
          </List.Item>
          <List.Item>
            <strong>Riesiges Bonusprogramm</strong>
          </List.Item>
        </List>
      }
    />

    <Content
      reverse
      spacing
      image={
        <Img
          fluid={data.contentImage1aGreen.childImageSharp.fluid}
          style={{ display: 'block' }}
          imgStyle={{ display: 'block' }}
          quality={100}
        />
      }>
      <Break Desktop />
      <Break Desktop />
      <Title margin>
        Abstand halten leicht gemacht.
      </Title>
      <p>
        Zahlen Sie mit Ihrer American Express Card einfach mit einer Handbewegung, so geben Sie Ihre Karte nicht mehr aus der Hand und kommen schneller an der Kasse vorbei.
      </p>
      <p>
        Das kontaktlose Bezahlen geht an vielen Automaten und in zahlreichen Geschäften – auch für Beträge über 50 Euro. Das Terminal zeigt Ihnen, ob die Eingabe Ihrer PIN erforderlich ist.
      </p>
    </Content>

    <Break Desktop />
    <Break Desktop />
    <Break Desktop />

    <Content
      spacing
      background
      image={
        <Img
          fluid={data.contentImage1Green.childImageSharp.fluid}
          style={{ display: 'block' }}
          imgStyle={{ display: 'block' }}
          quality={100}
        />
      }>
      <Title margin>
        Bei jeder Zahlung
        <br />
        Punkte sammeln ...
      </Title>
      Starke Marken und flexible Möglichkeiten, um das zu tun, was sie lieben – mit Membership Rewards®, dem Bonusprogramm von American Express®, sammeln Sie bei jeder Zahlung Punkte und haben die Freiheit diese so zu nutzen, wie Sie es wollen, z.B.:
      <br />
      <br />
      <List bold>
        <List.Item>Beim Tanken</List.Item>
        <List.Item>Beim Shoppen</List.Item>
        <List.Item>Im Restaurant</List.Item>
        <List.Item>Auf Reisen</List.Item>
        <List.Item>Bei Online-Einkäufen</List.Item>
      </List>
      <br />
      Jeder Euro bringt automatisch einen Membership Rewards Punkt. Ihre Punkte
      verfallen nicht<sup>4)</sup> und lassen sich flexibel einlösen.
    </Content>

    <Content
      reverse
      yAlign
      spacing
      image={
        <Img
          fluid={data.contentImage2Green.childImageSharp.fluid}
          style={{ display: 'block' }}
          imgStyle={{ display: 'block' }}
          quality={100}
        />
      }>
      <Title margin>
        ... und ganz nach
        <br /> Wunsch einlösen.
      </Title>
      Zum Beispiel in:
      <br />
      <br />
      <List bold>
        <List.Item>Tolle Sachprämien</List.Item>
        <List.Item>Unvergessliche Reisen</List.Item>
        <List.Item>Vielfältige Gutscheine</List.Item>
        <List.Item>Prämienflüge</List.Item>
        <List.Item>Spenden für den guten Zweck</List.Item>
      </List>
      <br />
      Oder begleichen Sie Ihre nächste Rechnung mit Punkten. Ihren Möglichkeiten
      sind kaum Grenzen gesetzt.
    </Content>

    <Content
      yAlign
      reverse
      background
      imageSmall
      image={
        <Img
          fluid={data.cardImageGreen.childImageSharp.fluid}
          style={{ display: 'block' }}
          imgStyle={{ display: 'block' }}
          quality={100}
        />
      }>
      <Title margin>
        Ab dem 2. Jahr kostenfrei – abhängig vom Jahresumsatz
      </Title>
      Die American Express Card  kostet Sie nur 5 Euro pro Monat und ab einem Kartenumsatz von 9.000 Euro im Jahr, bekommen Sie die monatlichen Beiträge eines Jahres im Folgejahr sogar komplett erstattet.<sup>1)</sup>
      <Break />
      <Break Desktop />
      <Break Desktop />
      <Break Desktop />
      <Break Desktop />
    </Content>

    <CardCSC
      url="https://www.amex-business.de/?sourcesuffix=AL03174387&cpid=0520CSGR01"
      card={data.cardImageGoldBusiness.childImageSharp.default}
      largeButton
      content={
        <>
          <CardCSCTitle>Sie sind selbstständig?</CardCSCTitle>
          <CardCSCContent>
            Die Business Gold Card<br />mit 150 Euro Startguthaben.
          </CardCSCContent>
        </>
      }
    />

    <ContentPay
      title={
        <>
          American Express und Apple Pay: <Break desktop /> jetzt auch in
          Deutschland
        </>
      }
      text={
        <p>
          Nutzen Sie alle Vorteile Ihrer American Express Card mit Apple Pay auf
          Ihrem iPhone und Ihrer Apple Watch. Es war noch nie so einfach,
          schnell und sicher, in Geschäften zu bezahlen.
        </p>
      }
      mobileImage={data.payMobileImageGreen}
      watchImage={data.watchImageGreen.childImageSharp.fixed}
      walletImage={data.walletImageGreen.childImageSharp.fixed}
      appImages={[
        data.appScreenImage1Green.childImageSharp.fixed,
        data.appScreenImage2Green.childImageSharp.fixed,
        data.appScreenImage3Green.childImageSharp.fixed,
        data.appScreenImage4Green.childImageSharp.fixed,
      ]}
    />

    <ContentApp
      title={
        <>
          Amex App:
          <br /> Kontoverwaltung kann so einfach sein
        </>
      }
      text={
        <p>
          Mit der American Express® App nehmen Sie Ihr Konto überall mit hin.
          Aktivieren Sie Ihre American Express Card, verwalten Sie
          Kontobewegungen, Kontodaten, Membership Rewards® Punkte und noch
          vieles mehr. Einfache Anmeldung mit Touch ID und Face ID (unterstützte
          Geräte vorausgesetzt).
        </p>
      }
      mobileImage={data.appMobileImageGreen}
    />

    <br />
    <br />
    <br />
    <br />
    <Break desktop />
    <Break desktop />
    <Break desktop />
    <Break desktop />

    <Content
      reverse
      image={
        <Img
          fluid={data.contentImage4Green.childImageSharp.fluid}
          style={{ display: 'block' }}
          imgStyle={{ display: 'block' }}
          quality={100}
        />
      }>
      <Title margin>
        Offers und exklusiver <br />Zugang zu Events.
      </Title>
      <p>
        Mit Amex Offers profitieren American Express Mitglieder von Nachlässen und Gutschriften oder erhalten zusätzliche Punkte bei zahlreichen Akzeptanzpartnern. Ganz einfach über die Amex App oder im Online-Kartenkonto.
      </p>
      <p>
        Wir haben für Sie die besten Plätze reserviert, auf den besten Veranstaltungen und mit den besten Extras – American Express Experiences®.
      </p>
    </Content>

    <br />
    <br />
    <Break desktop />
    <Break desktop />

    <BadgesCards
      card={data.cardImageGreen.childImageSharp.default}
      badgeRight={data.badgeRightImageGreen.childImageSharp.fixed}
    />

    <Features
      variant={variant}
      linkedin
      placement="btm"
      title={
        <>
          Ausgezeichneter
          <br /> Service mit Sicherheit
        </>
      }>
      <List color="white">
        <List.Item>
          Persönlicher telefonischer <strong>Service 24/7</strong>
        </List.Item>
        <List.Item>
          Kostenlose <strong>SMS- und E-Mail-Benachrichtigungen</strong>
        </List.Item>
        <List.Item>
          Sicher shoppen mit <strong>American Express SafeKey®</strong> und
          Ihrer <strong>persönlichen PIN</strong>
        </List.Item>
        <List.Item>
          Erweitertes <strong>90-tägiges Rückgaberecht</strong>
          <sup>2)</sup> für Ihre Einkäufe
        </List.Item>
        <List.Item>
          <strong>Umfassender Schutz</strong> bei unverschuldetem
          Kartenmissbrauch
        </List.Item>
        <List.Item>
          <strong>Kostenfreie Ersatzkarte</strong>, wenn die Karte verloren oder
          gestohlen wurde
        </List.Item>
        <List.Item>
          <strong>Online-Reiseservice</strong> für die Buchung von Hotels,
          Mietwagen und Flügen weltweit
        </List.Item>
      </List>
    </Features>

    <br />
    <br />
    <br />
    <Break desktop />

    <OnScroll>
      {inViewport => (
        <CardFlyout
          card={data.cardImageGreen.childImageSharp.default}
          transparent
          expanded={inViewport}
        />
      )}
    </OnScroll>

    <br />
    <br />

    <Steps
      variant={variant}
      linkedin
      placement="btm"
      title={
        <>
          Die American Express Card inkl. einer kostenfreien Zusatzkarte.{' '}
          <Steps.Space>Jetzt beantragen in nur 3 Schritten.</Steps.Space>
        </>
      }
      step1="American Express Card beantragen"
    />

    <br />
    <br />
    <br />

    <Footer>
      <p>
        <sup>1)</sup> Ab einem Kartenumsatz von 9.000 Euro im Jahr bekommen Sie die monatlichen Beiträge eines Jahres im Wert von 60 Euro im Folgejahr erstattet. Ein Beitrag von 5 Euro wird monatlich fällig. Im Rahmen der Kartennutzung können zudem Entgelte gem. AGB anfallen
      </p>
      <p>
        <sup>2)</sup> Alle Details zu den Leistungen und Versicherungen finden
        Sie{' '}
        <a
          href="https://www.americanexpress.com/content/dam/amex/de/benefits/bedingungen/Green_Card_Informationen.pdf"
          target="_blank"
          rel="noopener noreferrer">
          hier
        </a>
        .
      </p>
      <p>
        <sup>3)</sup> Der Gegenwert der Zusatzkarte wird nicht ausgezahlt bzw.
        nicht dem Kartenkonto gutgeschrieben, falls die Zusatzkarte nicht in
        Anspruch genommen wird.
      </p>
      <p>
        <sup>4)</sup> Solange Sie Inhaber einer aktiven American Express Karte
        sind und am Membership Rewards Programm teilnehmen, sind Ihre Membership
        Rewards Punkte unbegrenzt gültig.
      </p>

      <p>
        Alle detaillierten Informationen zu Schutz und Sicherheit finden Sie{' '}
        <a
          href="https://www.americanexpress.com/de/content/security/?inav=de_sitefooter_importantlinks_security"
          target="_blank"
          rel="noopener noreferrer">
          hier
        </a>
        .
      </p>
    </Footer>

    <div
      style={{ width: 0, height: 0, overflow: 'hidden' }}
      dangerouslySetInnerHTML={{ __html: tracking }}
    />
    <Optimize />
  </Layout>
)

export default GreenPage
